import React from "react";
import TabbedPage from "../shared/TabbedPage";
import translate from "../../../../i18n/translate";
import LiveLog from "../../LiveLog/LiveLog";
import TranslateSettings from "../TranslateSettings";
import DeleteTrans from "components/pages/settings/DeleteTrans";
import AllCompanies from "components/pages/settings/AllCompanies";
import ArabBank from "components/pages/settings/ArabBank";

// Operational tools that are not settings of any one provider.
const ToolsPage = ({ defaultTab }) => (
  <TabbedPage
    id="tools"
    title={translate("Tools")}
    intro={translate("toolsHint")}
    defaultTab={defaultTab}
    tabs={[
      { key: "liveLog", label: translate("Live Log"), render: () => <LiveLog /> },
      { key: "deleteTrans", label: translate("deleteTrans"), render: () => <DeleteTrans /> },
      { key: "allCompanies", label: translate("Global Updates"), render: () => <AllCompanies /> },
      { key: "arabBank", label: translate("arabBankCaptcha"), render: () => <ArabBank /> },
      { key: "translate", label: translate("Translate"), render: () => <TranslateSettings /> },
    ]}
  />
);

export default ToolsPage;
